import { Button, Box, styled, Typography } from '@mui/material';

export const Content = styled(Box)`
  padding: 1.5rem;
  user-select: none;
  text-align: center;
`;

export const StyledButton = styled(Button)`
  margin-top: 1rem;
`;

export const Image = styled('img')`
  margin: 1rem 0;
`;

export const StyledTypography = styled(Typography)`
  margin: 0.5rem 0 1rem;
`;
